<template>
  <div>
    <el-form
      ref="formRef"
      :model="searchForm"
      style="width:100%"
      :inline="true"
      :label-position="'right'"
      size="mini"
      :rules="formRules"
    >
      <el-form-item label="昵称/手机号">
        <el-input v-model="searchForm.primaryKey" clearable></el-input>
      </el-form-item>
      <el-form-item label="获取方式">
        <el-select
          v-model="searchForm.getType"
          clearable
          placeholder="请选择"
          style="width:150px"
        >
          <el-option
            v-for="item in getTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="优惠券CODE">
        <el-input v-model="searchForm.couponCode" clearable></el-input>
      </el-form-item>
      <el-form-item label="领取时间" prop="createTime">
        <el-date-picker
          v-model="searchForm.startTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.endTime"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="使用状态">
        <el-select
          v-model="searchForm.useStatus"
          clearable
          placeholder="请选择"
          style="width:150px"
        >
          <el-option
            v-for="item in useStatusOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="使用时间" prop="useTime">
        <el-date-picker
          v-model="searchForm.useTimeStart"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
        ~
        <el-date-picker
          v-model="searchForm.useTimeEnd"
          type="date"
          placeholder="选择日期"
          style="width:150px"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="loadPage(1)">查询</el-button>
        <el-button icon="el-icon-download" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      style="width: 100%"
      border
      size="mini"
      v-loading="loading"
    >
      <el-table-column
        type="index"
        label="序号"
        width="50"
        align="center"
      ></el-table-column>
      <el-table-column label="会员信息" align="center">
        <template slot-scope="scope">
          <span
            >{{ scope.row.subscriberName }} /
            {{ scope.row.subscriberPhoneNo }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="couponName"
        label="优惠券名称"
        align="center"
      ></el-table-column>
      <el-table-column prop="couponCode" label="优惠券编码" align="center">
      </el-table-column>
      <el-table-column prop="couponTypeName" label="优惠券类型" align="center">
      </el-table-column>
      <el-table-column prop="consumeTypeName" label="消费方式" align="center">
      </el-table-column>
      <el-table-column prop="useStatusName" label="使用状态" align="center">
      </el-table-column>
      <el-table-column
        prop="created"
        label="领取时间"
        align="center"
      ></el-table-column>
      <el-table-column label="有效期" align="center">
        <template slot-scope="scope">
          {{ scope.row.startTime || "--" }} ~ {{ scope.row.endTime || "--" }}
        </template>
      </el-table-column>
      <el-table-column
        prop="useTime"
        label="使用时间"
        align="center"
      ></el-table-column>
      <el-table-column prop="orderNo" label="订单号" align="center">
        <template slot-scope="scope">
          <!--el-link链接-->
          <el-link type="primary" @click="toOrderDetail(scope.row)">{{
            scope.row.orderNo
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            size="mini"
            @click="handleConsume(scope.row)"
            >核销</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="searchForm.startRow"
      :page-sizes="[10, 20, 50]"
      :page-size="searchForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="searchForm.total"
    >
    </el-pagination>
    <coupon-consume ref="consumeRef" @refresh="loadPage"></coupon-consume>
  </div>
</template>
<script>
import CouponConsume from "./components/couponConsume.vue";
import { queryCouponHistoryPageApi } from "@/api/subscriber";
import {
  couponGetTypeApi,
  couponUseStatusApi,
  couponTypeApi
} from "@/api/coupon";
import axios from 'axios'
import ip from '@/config/ip'
import store from '@/store/store'

export default {
  components: { CouponConsume },
  data() {
    return {
      searchForm: {
        startRow: 1,
        pageSize: 10,
        total: 0
      },
      // 优惠券类型
      couponTypeOptions: [],
      // 获取方式
      getTypeOptions: [],
      // 使用状态
      useStatusOptions: [],
      formRules: {
        createTime: [
          {
            validator: (rule, value, callback) => {
              if (
                this.searchForm.startTime &&
                this.searchForm.endTime &&
                this.searchForm.startTime.getTime() >
                  this.searchForm.endTime.getTime()
              ) {
                callback(new Error("结束时间必须大于开始时间"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        useTime: [
          {
            validator: (rule, value, callback) => {
              if (
                this.searchForm.useTimeStart &&
                this.searchForm.useTimeEnd &&
                this.searchForm.useTimeStart.getTime() >
                  this.searchForm.useTimeEnd.getTime()
              ) {
                callback(new Error("结束时间必须大于开始时间"));
                return;
              }
              callback();
            },
            trigger: "blur"
          }
        ]
      },
      tableData: [],
      loading: false
    };
  },
  created() {
    this.getBizCouponGetTypeOptions();
    this.getBizCouponUseStatusOptions();
    this.getBizCouponTypeOptions();
  },
  mounted() {
    this.loadPage();
  },
  methods: {
    loadPage(num) {
      this.$refs.formRef.validate(valid => {
        console.log(valid);
        if (valid) {
          if (num) {
            this.searchForm.startRow = num;
          }
          this._loadPage();
        }
      });
    },
    _loadPage() {
      this.loading = true;
      queryCouponHistoryPageApi(this.searchForm)
        .then(resp => {
          if (resp.data.status == 100) {
            this.tableData = resp.data.results.list;
            this.searchForm.total = resp.data.results.total;
          } else {
            this.$message({
              message: resp.data.message,
              type: "error"
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getBizCouponGetTypeOptions() {
      let _self = this;
      couponGetTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.getTypeOptions = resp.data.results;
        }
      });
    },
    getBizCouponUseStatusOptions() {
      let _self = this;
      couponUseStatusApi().then(resp => {
        if (resp.data.status == 100) {
          _self.useStatusOptions = resp.data.results;
        }
      });
    },
    getBizCouponTypeOptions() {
      let _self = this;
      couponTypeApi().then(resp => {
        if (resp.data.status == 100) {
          _self.couponTypeOptions = resp.data.results;
        }
      });
    },
    handleSizeChange(pageSize) {
      this.searchForm.pageSize = pageSize;
      this.loadPage();
    },
    handleCurrentChange(page) {
      this.searchForm.startRow = page;
      this.loadPage();
    },
    /**
     * 订单详情
     * @param {*} orderNo
     */
    toOrderDetail(row) {
      this.$router.push({
        path: "/visitRepair",
        query: {
          orderId: row.orderId,
          orderNo: row.orderNo
        }
      });
    },
    /**
     *  核销
     * @param {*} row
     */
    handleConsume(row) {
      this.$refs.consumeRef.open(row);
    },
    handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "正在生成文件，请稍等111...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      axios({
        url: `${ip.Ips.ip1}/biz/coupon/history/export`,
        method: "post",
        headers: {
          token: `${store.state.token}`
        },
        data: this.searchForm,
        responseType: "blob"
      })
        .then(res => {
          loading.close();
          let fileName = res.headers["content-disposition"].split(";")[1].trim().split('filename=')[1].split('"')[1]
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            window.navigator.msSaveOrOpenBlob(blob, fileName);
          } else {
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            const link = document.createElement("a");
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute(
              "download",
              fileName
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          }
        })
        .catch(error => {
          this.$Message.error(error.message);
        });
    },
  }
};
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// couponHistory.vue?68992279